// Modules
import { useEffect } from 'react'

// Application
import { useAccountContext } from 'context'
import { useAccountService } from 'services/account'

const LIVIA_LS_KEY = '@Livia'

export const useAccountMDMHook = () => {
    const {
        state,
        operations: { setSubmitting, setContact, setPassword, resetAccountState, ...operations },
    } = useAccountContext()
    const { checkAccountService, createLogin, resendToken, ...service } = useAccountService()

    useEffect(() => {
        if (!state.hasMounted) {
            const personalData = sessionStorage.getItem('@LiviaAuth:SignUpPersonalData')
            const biologicalSex = sessionStorage.getItem('@LiviaAuth:SignUpBiologicalSex')
            const postalCode = sessionStorage.getItem('@LiviaAuth:SignUpPostalCode')
            const contact = sessionStorage.getItem('@LiviaAuth:SignUpContact')
            const userId = sessionStorage.getItem('@LiviaAuth:SignUpUserId')
            const phoneContactList = sessionStorage.getItem('@LiviaAuth:SignUpPhoneList')
            const emailContactList = sessionStorage.getItem('@LiviaAuth:SignUpEmailList')

            operations.setAccount({
                name: personalData ? JSON.parse(personalData).name : null,
                socialName: personalData ? JSON.parse(personalData).socialName : null,
                cpf: personalData ? JSON.parse(personalData).cpf : null,
                birthDate: personalData ? JSON.parse(personalData).birthDate : null,
                term: personalData ? JSON.parse(personalData).term : null,
                postalCode: postalCode ? JSON.parse(postalCode) : null,
                biologicalSex: biologicalSex ? JSON.parse(biologicalSex) : null,
                password: '',
                contact: contact ? { ...JSON.parse(contact) } : null,
                id: userId ? JSON.parse(userId) : null,
                phoneContacts: phoneContactList ? JSON.parse(phoneContactList) : undefined,
                emailContacts: emailContactList ? JSON.parse(emailContactList) : undefined,
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.hasMounted])

    const confirmToken = async (token: string) => {
        const { cpf: userName, password } = state
        const dataConfirmation = {
            userName,
            token,
            password,
        }
        const data = await service.confirmToken(dataConfirmation)

        if (!data || !data.confirmToken || !data.confirmToken.authentication) {
            return false
        }
        localStorage.setItem(
            LIVIA_LS_KEY,
            JSON.stringify({
                token: data.confirmToken.authentication.access_token,
                refreshToken: data.confirmToken.authentication.refresh_token,
            }),
        )

        return true
    }

    return {
        ...state,
        ...operations,
        confirmToken,
        checkAccountService,
        createLogin,
        setSubmitting,
        setContact,
        setPassword,
        resetAccountState,
        resendToken,
    }
}
